import api from '../../../services/api';

/**
 * Service to handle all analytics-related API calls.
 */
export const fetchAnalyticsAll = async (params) => {
    return api.get('/rfp/analytics/all', { params });
};

export const fetchAnalyticsMetrics = async (params) => {
    return api.get('/rfp/analytics/metrics', { params });
};

export const fetchAnalyticsTeam = async (params) => {
    return api.get('/rfp/analytics/team', { params });
};

export const exportAnalyticsReport = async (formattedRange) => {
    return api.get(`/rfp/analytics/export?time_range=${formattedRange}`, {
        responseType: 'blob'
    });
};
